import { Card, DropdownSelect, TextInput, Toggle, useOutsideClick } from "@avenueops/web-components";
import { CalendarIcon, VariableIcon } from "@heroicons/react/24/outline";
import RadioGroupList from "components/generic-building-blocks/RadioGroupList";
import moment from "moment";
import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setSlackRecipientListValue } from "../../../backend-shared/src";
import UncontrolledInputField from "./UncontrolledInputField";

interface Props {
  onChange: (_: string) => void;
  value?: string;
  rounded?: boolean;
  includeHours?: boolean;
  timeZone?: string;
}

function isValidDate(dateStr: string) {
  const date = new Date(dateStr);
  return date.toString() !== "Invalid Date";
}

export default function TemplateableAvenueDatePicker({ onChange, value, rounded = true, includeHours = true, timeZone }: Props) {
  const [fieldType, setFieldType] = useState<string>(!value ? "DATE" : isValidDate(value) ? "DATE" : "TEMPLATE");
  const [editingField, setEditingField] = useState<boolean>(false);
  const editingFieldRef = useRef<HTMLDivElement>(null);
  useOutsideClick(editingFieldRef, () => setEditingField(false));

  const onChangeWrapper = (date: Date) => {
    onChange(date.toISOString());
  };

  return (
    <div className="w-auto relative">
      <div onClick={() => setEditingField(!editingField)}>
        <UncontrolledInputField disabled={editingField} onChange={() => {}} value={fieldType === "DATE" && value ? new Date(value).toDateString() : value} />
      </div>
      {editingField ? (
        <div ref={editingFieldRef}>
          <div className=" absolute bottom-8 right-20">
            <Card>
              <div className="flex flex-col w-64 items-center gap-4 p-4 bg-white shadow-md rounded">
                <RadioGroupList
                  padding="p-2"
                  setValue={(value: string) => {
                    onChange("");
                    setFieldType(value);
                  }}
                  value={fieldType}
                  settings={[
                    { value: "TEMPLATE", title: "Template", icon: <VariableIcon className="text-gray-500 h-4 w-4 self-center mr-1 -ml-3" /> },
                    { value: "DATE", title: "Date", icon: <CalendarIcon className="text-gray-500 h-4 w-4 self-center mr-1 -ml-3" /> },
                  ]}
                />
                {fieldType === "TEMPLATE" ? (
                  <TextInput
                    name="other_input"
                    defaultValue={value}
                    onChange={(event) => {
                      onChange(event.target.value);
                    }}
                  />
                ) : (
                  <DatePicker
                    className={`bg-white-100 w-full min-h-[42px] text-center cursor-pointer text-gray-400 text-sm border border-gray-300 py-1.5 ${
                      rounded ? "rounded-full" : ""
                    }`}
                    onChange={onChangeWrapper}
                    selected={value ? new Date(value) : undefined}
                    showTimeInput
                    dateFormat={`MM/dd/yyyy ${includeHours ? "hh:mm aa" : ""} `}
                  />
                )}
              </div>
            </Card>
          </div>
        </div>
      ) : null}
    </div>
  );
}
